import { render } from "./StudentEvaluationsDataTable.vue?vue&type=template&id=661a8498&scoped=true"
import script from "./StudentEvaluationsDataTable.vue?vue&type=script&lang=js"
export * from "./StudentEvaluationsDataTable.vue?vue&type=script&lang=js"

import "./StudentEvaluationsDataTable.vue?vue&type=style&index=0&id=661a8498&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-661a8498"]])

export default __exports__